/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SeatAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import ConfirmationDialog from './ConfirmationDialog/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SeatAction({
  children,
  viewPath = "/DesignSystem/SeatAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ConfirmationDialog/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ConfirmationDialog/Content'))}
>
{children}
</Children>
<ConfirmationDialog
  viewPath={`${viewPath}/ConfirmationDialog`}
/>
</React.Fragment>)
}